import { render, staticRenderFns } from "./C.vue?vue&type=template&id=06885f96&scoped=true"
import script from "./C.vue?vue&type=script&lang=js"
export * from "./C.vue?vue&type=script&lang=js"
import style0 from "./C.vue?vue&type=style&index=0&id=06885f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06885f96",
  null
  
)

export default component.exports